// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"d8c6a0d4","145":"acc95c23","317":"e67facee","477":"4fc561e1","685":"8aae0a18","787":"7a08595a"}[chunkId] + ".chunk.js";
};